if (!customElements.get('bp-brand-slider')) {
  customElements.define('bp-brand-slider', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (this.controller) return;
      const track = this.querySelector('.bp-brand-track');
      if (!track) return;
      this.controller = new AbortController();
      const buttons = [...this.querySelectorAll('button[data-direction]')];
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        buttons.forEach(button => {
          button.disabled = Number(button.dataset.direction) < 0 ? track.scrollLeft <= 2 : track.scrollLeft >= max - 2;
        });
      };
      buttons.forEach(button => button.addEventListener('click', () => {
        const item = track.querySelector('.bp-brand-item');
        const distance = item.getBoundingClientRect().width + 14;
        track.scrollBy({left: Number(button.dataset.direction) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }, {signal: this.controller.signal}));
      track.addEventListener('scroll', update, {passive: true, signal: this.controller.signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      track.querySelectorAll('img').forEach(img => img.addEventListener('load', update, {signal: this.controller.signal}));
      update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = null;
    }
  });
}
